import { api_url } from "@/config/api_url";
import axios from 'axios';
import { defineStore } from "pinia";
import { useNotificationStore } from "./notificationStore";

export const useUserStore = defineStore('userStore',{
    state:() => ({
        users:[],
        user:{},
        ownerMission:{},
        isAdmin:false,
        loading:false,
    }),

    actions:{
        async fetchUsers(){
            this.loading = true;
            try {
                const result = await axios.get(`${api_url}/admin/user/getAll`);
                this.users = result.data.data;
                this.loading = false;
            } catch (error) {
                this.handleError(error);
                this.loading = false;
            }
        },

        async getActiveUser(){
            const token = localStorage.getItem('token');
		    if(token == "" || token == null || token == undefined) {
		    	this.isAdmin = false;
                this.user = null;
		    	return;
		    }
            try{
                this.user = (await axios.get(`${api_url}/admin/user/activeUser/${token}`)).data;
            }catch(err){
                this.isAdmin = false;
                this.user = null;
                console.log("Error while trying to get active user",err)
                return;
            }
		},

        async getRoles(){
            return axios.get(`${api_url}/admin/role/getAll`);
        },

        async getMissionPerms(mission_id) {
            const response = await axios.get(`${api_url}/admin/mission/permission/getUserPermissionsOnMissions`, {
                params: {
                    mission_id: mission_id,
                    user_id: this.user.id 
                }});
            if(response.status == 200){
                return response.data.perms;
            }
        },

        async logIn(email,password){
            axios.post(`${api_url}/login`, { email: email, password: password })
                .then(response => {
                    if (response.data.token) {
                        localStorage.setItem('token', response.data.token);
                        localStorage.setItem('perms', response.data.perms);
                        localStorage.setItem('user',response.data.user.name);
                        localStorage.setItem('userId',response.data.user.id);
                        location.reload();
                    }
                }).catch(error => {
                    localStorage.clear();
                    this.handleError(error)
                });
        },

        async createUser(newUser) {
            try {
                const response = await axios.post(`${api_url}/admin/user`, newUser);
                this.users = response.data.data;
                return response;
            } catch (error) {
                this.handleError(error);
            }
        },

        async editUser(editUser,id) {
            try {
                const response = await axios.put(`${api_url}/admin/user/${id}`, editUser);
                this.users = response.data.data;
                let isAdmin = this.user.isAdmin;

                let actualUserId = this.user.id;
                if(actualUserId==id){
                    this.user = this.users.find((user)=> user.id == id);
                    this.user.isAdmin = isAdmin;
                } 

                
                useNotificationStore().setNotification(
                "User Updated",
                "The user has been successfully updated.",
                "mdi-check-circle",
                "green"
                );                
                return response;
            } catch (error) {
                this.handleError(error);
            }
        },

        async getOwneer(id){
            try {
                const response = await axios.get(`${api_url}/admin/user/${id}`);
                this.ownerMission = response.data.data;
            }catch(error){
                this.handleError(error);
            }
        },

        async deleteUser(id){
            try {
                const response = await axios.delete(`${api_url}/admin/user/${id}`);
                this.users = response.data.data;  
                return response;
            } catch (error) {
                this.handleError(error);
            }
        },
        
        handleError(error) {
            useNotificationStore().setNotification('Error', error.response.data, 'mdi-alert', 'error');
        },
    }
})